module.exports = __webpack_public_path__ + "static/media/ObserverIcon.afb177b9.png";